import ApiStorage from '../redux/ApiStorage';
import { fetchFromUrlPOSTAsync } from '../utils/UrlHelper';
import UtilString from '../utils/utilString';
const URL_LOGIN = 'users/auth/login';
const URL_Logout = 'users/auth/logout';
const URL_REFRESH_TOKEN = '/users/auth/refresh_token';
const URL_FORGOT_PASSWORD = '/users/auth/forgot_password';
const URL_FORGOT_PASSWORD_VERIFY_CODE =
  '/users/auth/forgot_password/verify_code';
const URL_FORGOT_PASSWORD_RESET = '/users/auth/forgot_password/reset_password';

const fs = {
  login: async (email, password) => {
    const urlParams = {
      email: email,
      password: UtilString.md5(password),
    };
    const result = await fetchFromUrlPOSTAsync(URL_LOGIN, urlParams);
    return result;
  },
  logout: async () => {
    const urlParams = [];
    const result = await fetchFromUrlPOSTAsync(URL_Logout, urlParams);
    ApiStorage.clearUser();
    return result;
  },
  forgotPasswordRequest: async (email) => {
    const urlParams = {
      saveData: {
        email,
      },
    };
    const result = await fetchFromUrlPOSTAsync(URL_FORGOT_PASSWORD, urlParams);
    return result;
  },
  forgotPasswordVerifyCode: async (values) => {
    const urlParams = {
      saveData: {
        ...values,
        digitCode: UtilString.md5(values.digitCode),
      },
    };
    const result = await fetchFromUrlPOSTAsync(
      URL_FORGOT_PASSWORD_VERIFY_CODE,
      urlParams
    );
    return result;
  },
  resetForgotPassword: async (values) => {
    const urlParams = {
      saveData: {
        ...values,
        digitCode: UtilString.md5(values.digitCode),
        password: UtilString.md5(values.password),
      },
    };
    const result = await fetchFromUrlPOSTAsync(
      URL_FORGOT_PASSWORD_RESET,
      urlParams
    );
    return result;
  },
};

const loc = {};

const AuthActions = Object.assign(fs, loc);

export default AuthActions;

export { URL_REFRESH_TOKEN };
